import SwipeList from './SwipeList';
export default SwipeList;